import classnames from 'classnames';
import * as React from 'react';
import '../router/index.js';
import '../text/index.js';
import { link, inner } from './link.css.js';
import { useRouter } from '../router/router.js';
import { Text } from '../text/text.js';

/**
 * Renders an anchor (`<a>`) or a button (`<button>`), depending on whether `href` or `as` prop is defined.
 */
const Link = React.forwardRef(function Link({ children, className, size = 'inherit', weight, as = 'a', onClick: propOnClick, ...rest }, ref) {
    const handleClick = React.useCallback((event) => {
        event.stopPropagation();
        propOnClick?.(event);
    }, [propOnClick]);
    const { onClick } = useRouter({ onClick: handleClick });
    return (React.createElement(Text, { as: as, ...rest, onClick: onClick, ref: ref, className: classnames(link, className), size: size, weight: weight, type: as === 'button' ? 'button' : undefined },
        React.createElement("span", { className: inner }, children)));
});

export { Link };
